import UserPreferencesComponent from './user-preferences.component';
import * as userPreferencesActions from './user-preferences.actions';
import { userPreferencesReducer } from './user-preferences.reducer';

export { UserPreferencesComponent, userPreferencesActions, userPreferencesReducer };



// WEBPACK FOOTER //
// src/acct/preferences/index.js